import { Container, Grid, Paper } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Link, Switch, useHistory } from 'react-router-dom';
import useStylesPaper from '../../../styles/paper.styles';
import useStyles from '../../../styles/useStyles';
import useProductReservationRoutes from '../hooks/useProductReservationRoutes';
import { useSettings } from '../hooks/useSettings';
import { EProductReservationTabs } from '../types';
import applicationInsightsIcon from '../../../Assets/application-insights.svg';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';

import ConfigurationDocumentPlaceholder from './ConfigurationDocumentPlaceholder/ConfigurationDocumentPlaceholder';
import ConfigurationDocumentLink from './ConfigurationDocumentLink/ConfigurationDocumentLink';
import useSecurity from '../hooks/useSecurity/useSecurity';
import { LoadingPanel } from '../../../ui';
import { useQueryClient } from 'react-query';

import applicationSettings from '../../../applicationSettings.json';
import { SabsPrivateRoute } from '../../../components/PrivateRoute';

const Menu = () => {
    const classes = useStyles();
    const history = useHistory();
    const classesPaper = useStylesPaper();
    const { routes, path } = useProductReservationRoutes();
    const { changeTab, currentTab } = useSettings();
    const [tabsValue, setTabsValue] = useState('configuration-placeholder');
    const accessDeniedPath = '/access-denied';
    const { isLoaded, isPageAuthorized } = useSecurity();

    const queryClient = useQueryClient();

    useEffect(() => {
        if (isLoaded) {
            if (!currentTab) {
                history.push(path + '/configuration-placeholder');
            } else {
                setTabsValue(currentTab);
            }
        }
    }, [currentTab, setTabsValue, isLoaded]);

    return (
        <Container maxWidth="xl">
            {isLoaded && (
                <Grid container spacing={3} justify="center">
                    <Grid container spacing={3} justify="center">
                        <Grid item md={12}>
                            <Paper className={classesPaper.root} style={{ height: '56px' }}>
                                <Tabs
                                    value={tabsValue}
                                    centered
                                    TabIndicatorProps={{
                                        style: {
                                            backgroundColor: '#8dd9c8',
                                        },
                                    }}
                                    className={classes.tab}
                                >
                                    <Tab
                                        className={classes.tabItem}
                                        label="placeholder"
                                        value={'configuration-placeholder'}
                                        component={Link}
                                        to={routes['configurationPlaceholder']}
                                        onClick={() => {
                                            queryClient.refetchQueries('placeholders');
                                            changeTab(EProductReservationTabs.configurationPlaceholder);
                                        }}
                                    />
                                    <Tab
                                        className={classes.tabItem}
                                        label="document link"
                                        value={'configuration-document-link'}
                                        component={Link}
                                        to={routes['configurationDocumentLink']}
                                        onClick={() => {
                                            queryClient.refetchQueries('document-links');
                                            changeTab(EProductReservationTabs.configurationDocumentLink);
                                        }}
                                    />
                                    <Tab
                                        className={classes.tabItem}
                                        label="Application Insights"
                                        component={Link}
                                        to={{
                                            pathname: applicationSettings.applicationInsightsLogs,
                                        }}
                                        icon={
                                            <img
                                                alt="Application Insights"
                                                style={{ height: 25, width: 20 }}
                                                src={applicationInsightsIcon}
                                            />
                                        }
                                        iconPosition="start"
                                        target="_blank"
                                    />
                                </Tabs>
                            </Paper>
                        </Grid>
                        <Grid item md={12}>
                            <Switch>
                                <SabsPrivateRoute
                                    path={routes['configurationDocumentLink']}
                                    redirectTo={accessDeniedPath}
                                    authorize={isPageAuthorized}
                                >
                                    <Paper className={classesPaper.defaultPaper}>
                                        <ConfigurationDocumentLink />
                                    </Paper>
                                </SabsPrivateRoute>
                                <SabsPrivateRoute
                                    path={routes['configurationPlaceholder']}
                                    redirectTo={accessDeniedPath}
                                    authorize={isPageAuthorized}
                                    exact
                                >
                                    <Paper className={classesPaper.defaultPaper}>
                                        <ConfigurationDocumentPlaceholder />
                                    </Paper>
                                </SabsPrivateRoute>
                            </Switch>
                        </Grid>
                    </Grid>
                </Grid>
            )}
            {!isLoaded && <LoadingPanel />}
        </Container>
    );
};

export default Menu;
